// extracted by mini-css-extract-plugin
export default {"root":"snqgH1oswi"};